import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    {...props}
  >
    <g>
      <path d="M17 13.4004C17.8837 13.4004 18.5996 14.1163 18.5996 15V17C18.5996 17.8837 17.8837 18.5996 17 18.5996H15C14.1163 18.5996 13.4004 17.8837 13.4004 17V15C13.4004 14.1163 14.1163 13.4004 15 13.4004H17ZM5 7.40039C5.88366 7.40039 6.59961 8.11634 6.59961 9V11C6.59961 11.8837 5.88366 12.5996 5 12.5996H3C2.11634 12.5996 1.40039 11.8837 1.40039 11V9C1.40039 8.11634 2.11634 7.40039 3 7.40039H5ZM17 1.40039C17.8837 1.40039 18.5996 2.11634 18.5996 3V5C18.5996 5.88366 17.8837 6.59961 17 6.59961H15C14.1163 6.59961 13.4004 5.88366 13.4004 5V3C13.4004 2.11634 14.1163 1.40039 15 1.40039H17Z" />
      <path d="M13 4H11C10.4477 4 10 4.44772 10 5V15C10 15.5523 10.4477 16 11 16H13M10 10.1H7" />
    </g>
    <defs>
      <clipPath id="clip0_2956_7678">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
